const user = {
	name: 'Benutzer | Melder',
	icon: 'fas fa-user',
	fields: {
		hp_id: 'ID',
		lastname: 'Person',
		email: 'E-Mail',
		tos: 'Nutzungsbedingungen',
		privacy: 'Datenschutz',
		logins_count: 'Logins',
		welcome: 'Versendet',
		created_at: 'Erstellt',
		latest_login: {
			created_at: 'Letzte Anmeldung',
		},
	},
}

export default user
